import "./MoreInformation.css";
export const TimeCommitment = (
  <div className="info-container small flex flex-row mr-auto ml-auto">
    <div className="info-column small flex flex-column ">
      <text className="sub-title">Specific time commitment</text>
      <text className="paragraph">
        By agreeing on specific time commitments, each founder is held
        accountable for their role in the company. It provides a clear
        understanding of what is expected of each co-founder and ensures that
        everyone is contributing to the company's success.
      </text>
      <text className="paragraph">
        Different founders may have different specific time commitments for
        several reasons:
      </text>
      <text className="paragraph">
        Founders may have other commitments, such as a full-time job or family
        obligations, that limit the amount of time they can commit to the
        company. In this case, it may be necessary to agree on a different time
        commitment. {""}
        Founders may also have different roles and responsibilities within the
        company, which may require different amounts of time.
      </text>
      <text className="paragraph">
        In any case, it's important for co-founders to have open and honest
        discussions about their time commitments and to come to a mutually
        agreed-upon arrangement. This can help to avoid misunderstandings and
        conflicts down the line.
      </text>
    </div>
  </div>
);
